import { ConsistentWith } from '@material-ui/core';
import React, { ComponentType, PureComponent } from 'react';
import getDisplayName from 'recompose/getDisplayName';
import { ResolvedUrls } from '../utils/resolver';
import { CdnUrlProvider } from './Cdn/CdnUrlProvider';

export interface WithCdn {
  cdnUrls: ResolvedUrls;
}

/**
 * Similar to Material UI's withStyles/withTheme, `withCdn` passes down a `cdnUrls` prop down to a component.
 *
 * `cdnUrls` contains base uris for:
 *
 * - serkoCdn
 * - zenoCdn
 * - webApiUrl
 * - robotoUrl
 * - robotoCondensedUrl
 */
export const withCdn = () => <P extends ConsistentWith<P, WithCdn>>(
  Component: ComponentType<P & WithCdn>,
): ComponentType<P> => {
  class WithCdnInner extends PureComponent<P> {
    public static displayName = 'WithCdn';
    public render() {
      return (
        <CdnUrlProvider.Consumer>
          {cdnUrls => <Component cdnUrls={cdnUrls} {...this.props} />}
        </CdnUrlProvider.Consumer>
      );
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    WithCdnInner.displayName = `WithCdn(${getDisplayName(Component)})`;
  }

  return WithCdnInner;
};
